import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from './ui/card';
import { Link } from 'react-router-dom';
import { FileText, CheckCircle, ArrowRight } from 'lucide-react';
import GuideDownloadForm from './GuideDownloadForm';
import { guideTexts } from '../data/guideTexts';
import { suspendedSlugs } from '../data/suspendedPageContent';

const GuideSection = ({ location, articleLink = false }) => {
  const { language } = useLanguage();
  const g = guideTexts[language] || guideTexts.es;

  return (
    <section id="guia" className="py-16 lg:py-20 bg-slate-900 relative overflow-hidden" data-testid={`guide-section-${location}`}>
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-red-500/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-red-500/15 text-red-300 text-sm font-semibold mb-6">
            <FileText className="w-4 h-4 mr-2" />{g.badge}
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white leading-tight mb-5">{g.title}</h2>
          <p className="text-slate-300 text-lg leading-relaxed mb-8">{g.subtitle}</p>
          <ul className="space-y-3">
            {g.bullets.map((b) => (
              <li key={b} className="flex items-start gap-3 text-slate-200">
                <CheckCircle className="w-5 h-5 mt-0.5 shrink-0 text-green-400" />{b}
              </li>
            ))}
          </ul>
          {articleLink && (
            <Link to={suspendedSlugs[language] || suspendedSlugs.es} data-testid={`guide-article-link-${location}`}
              className="inline-flex items-center mt-8 text-red-300 hover:text-white font-semibold transition-colors">
              {g.articleLink}<ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          )}
        </div>
        <Card className="bg-white border-0 rounded-2xl shadow-2xl">
          <CardContent className="p-6 sm:p-8">
            <h3 className="text-xl font-bold text-slate-800 mb-5">{g.formTitle}</h3>
            <GuideDownloadForm location={location} />
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default GuideSection;
